import React, { Component } from "react";
import { connect } from "react-redux";
import * as sanofiActions from "../../store/actions/Index";
import * as authActions from "../../store/actions/auth";
import * as ActionTypes from "../../store/actions/ActionTypes";
import AppBar from "../../components/AppBar/AppBar";
import Container from "@material-ui/core/Container";
import SideMenu from "../../components/SideMenu/SideMenu";
import Users from "../Users/Users";
import Questions from "../Questions/Questions";
import TopQuestions from "../TopQuestions/TopQuestions";
import Analytics from "../Analytics/Analytics";

class Manager extends Component {
	state = {
		fieldValues: {
			image: ""
		},
		loading: false,
		decisionModalOpen: false,
		modifyFormModalOpen: false,
		modifyTextFormOpen: false,
		idToDelete: 0,
		idToUpdate: 0,
		deleting: false,
		
		analytics_data: {"country":0, 
		"category":0, 
		"period":1}
	};

	componentDidMount() {


		this.props.onLoadUsers(this.props.token);
		this.props.loadQuestions();
		this.props.loadTopQuestions();
		this.props.onLoadAnalytics(this.state.analytics_data);

	}

	handleSideMenu = () => {
		this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
	};

	render() {
		const containerStyle = {
			marginTop: "50px"
		};

		let questions = this.props.questionsMenuOpen ? (
			<Questions
				questions={this.props.questions}
				loadQuestions={this.props.loadQuestions}
				loadLevels={this.props.loadLevels}
				levels = {this.props.levels}
				levelCategories ={this.props.levelCategories}
				loadLevelCategories={this.props.loadLevelCategories}
				handleSaveQuestion={this.props.saveQuestion}
				handleUpdateQuestion={this.props.updateQuestion}
				handleSaveQuestionConnect={this.props.saveQuestionConnect}
				handleUpdateQuestionConnect={this.props.updateQuestionConnect}
				deleteQuestion={this.props.deleteQuestion}
				idquestion={this.props.idquestion}
				country={this.props.country}
				token={this.props.token}
			/>
		) : null;

		let topquestions = this.props.topquestionsMenuOpen ? (
			<TopQuestions
				topquestions={this.props.topquestions}
				token={this.props.token}
			/>
		) : null;
		let users = this.props.usuariosMenuOpen ? (
			<Users
				users={this.props.usersList}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadUsersGeneral={this.props.onLoadUsers}
				loadUsersMonth={this.props.onLoadUsersMonth}
				loadUsersWeek={this.props.onLoadUsersWeek}
				createUser={this.props.createUser}
				deleteUser={this.props.deleteUser}
				country={this.props.country}
			/>
		) : null;

		let analytics = this.props.analyticsMenuOpen ? (
			<Analytics
				analytics={this.props.ana_efficiency}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
				loadAnalytics={this.props.onLoadAnalytics}
				country={this.props.country}
			/>
		):null;

		return (
			<div>
				<AppBar
					openMenu={this.props.handleOpenSideMenu}
					onClickLogout={this.props.handleLogout}
				/>
				<SideMenu
					open={this.props.sideMenuOpen}
					handleOpenUsuarios={this.props.handleOpenUsuarios}
					handleOpenQuestions={this.props.handleOpenQuestions}
					handleOpenTopQuestions={this.props.handleOpenTopQuestions}
					handleOpenAnalytics={this.props.handleOpenAnalytics}
				/>
				<Container fixed style={containerStyle}>
					{users}
					{questions}
					{topquestions}
					{analytics}
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => {

	return {
		questions: state.reducer.questions,
		topquestions: state.reducer.topquestions,

		levels: state.reducer.levels,
		levelCategories: state.reducer.levelCategories,
		sideMenuOpen: state.reducer.sideMenuOpen,
		usuariosMenuOpen: state.reducer.usuariosMenuOpen,
		questionsMenuOpen: state.reducer.questionsMenuOpen,
		topquestionsMenuOpen: state.reducer.topquestionsMenuOpen,
		analyticsMenuOpen: state.reducer.analyticsMenuOpen,
		token: state.authReducer.token,
		usersList: state.reducer.users,
		ana_efficiency: state.reducer.analytics
	};
};

const mapDispatchToProps = dispatch => {
	return {
		loadQuestions: () => dispatch(sanofiActions.loadQuestions()),
		loadTopQuestions: () => dispatch(sanofiActions.loadTopQuestions()),

		loadLevels: (idcategory) => dispatch(sanofiActions.loadLevels(idcategory)),
		loadLevelCategories: (idlevel) => dispatch(sanofiActions.loadLevelCategories(idlevel)),
		saveQuestion: (question) => dispatch(sanofiActions.saveQuestion(question)),
		updateQuestion: (question) => dispatch(sanofiActions.updateQuestion(question)),
		updateQuestionConnect: (question) => dispatch(sanofiActions.updateQuestionConnect(question)),
		deleteQuestion: (idquestion) => dispatch(sanofiActions.deleteQuestion(idquestion)),

		saveQuestionConnect: (question) => dispatch(sanofiActions.saveQuestionConnect(question)),

		onLoadAnalytics: (anarequest) => dispatch(sanofiActions.loadAnalytics(anarequest)),

		onLoadUsers: token => dispatch(sanofiActions.loadUsers(token)),
		onLoadUsersMonth: token => dispatch(sanofiActions.loadUsersMonth(token)),
		onLoadUsersWeek: token => dispatch(sanofiActions.loadUsersWeek(token)),
		handleOpenSideMenu: () =>
			dispatch({ type: ActionTypes.OPENCLOSE_SIDEMENU }),
		handleOpenUsuarios: () => dispatch({ type: ActionTypes.OPEN_USUARIOS }),		
		handleOpenQuestions: () => dispatch({ type: ActionTypes.OPEN_QUESTIONS }),
		handleOpenTopQuestions: () => dispatch({ type: ActionTypes.OPEN_TOPQUESTIONS }),
		handleOpenAnalytics: () => dispatch({type: ActionTypes.OPEN_ANALYTICS }),
		handleLogout: () => dispatch(authActions.authLogOut()),
		createUser: (token, user) => dispatch(sanofiActions.createUser(token, user)),
		deleteUser: (token, user) => dispatch(sanofiActions.deleteUser(token, user))

	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
